import * as React from "react";
import MainLayout from "../components/mainlayout";

// markup
const IndexPage = () => {
  return <MainLayout></MainLayout>;
};

export default IndexPage;
